export const CoreTagsIdMapName = 'CoreTagsIdMap';
